const bands = {
  band1: {
    name: 'Radiohead',
    image: 'https://cdn.pitchfork.com/albums/6556/homepage_large.dddaf5bb.jpg',
    desc:
      'Radiohead were not only among the first bands to figure out how to use the Internet, but to make their music sound like it, and they kicked off this ridiculously retro decade with the rare album that didn’t seem retro.',
    status: 'available',
  },

  band2: {
    name: 'Arcade Fire',
    image: 'https://cdn4.pitchfork.com/albums/448/homepage_large.2099047d.jpg',
    desc:
      'Will there ever be another album like Funeral? Sounds silly considering the second half of this decade has seen plenty of bands establish nice careers by ripping off the communal euphoria that Arcade Fire made fresh after four years of rock records that boasted metropolitan chic, emotional austerity, or lyrical removal– the music was amazing...',
    status: 'available',
  },

  band3: {
    name: 'Daft Punk',
    image: 'https://cdn.pitchfork.com/albums/2117/homepage_large.d23a880a.jpg',
    desc:
      'Daft Punk’s first album had helped refresh house music in the mid 1990s; the second went further, rewriting electronic pop’s pleasure principles to such a degree that when it came out a lot of people thought Discovery must be a put-on.',
    status: 'available',
  },

  band4: {
    name: 'Wilco',
    image: 'https://cdn2.pitchfork.com/albums/8535/homepage_large.7aa808cd.jpg',
    desc:
      'Jeff Tweedy had allegedly been boning up on World War II while he wrote many of the songs that would become Yankee Hotel Foxtrot, an all too fitting lead-up to Wilco’s well-documented battles with the record industry as well as within the band itself.',
    status: 'available',
  },

  band5: {
    name: 'Jay-Z',
    image: 'https://cdn.pitchfork.com/albums/4168/homepage_large.c77499e7.jpg',
    desc:
      'When it comes to prophetic hip-hop album titles, Ready to Die was the most tragically accurate of the 1990s. This decade, The Blueprint was rap’s supreme soothsayer: a grand layout too enamored with life to entertain fatalism.',
    status: 'available',
  },

  band6: {
    name: 'Modest Mouse',
    image: 'https://cdn4.pitchfork.com/albums/5290/homepage_large.789479e8.jpg',
    desc:
      'The Moon & Antarctica is easily Modest Mouse’s most ambitious album, a staggering leap in vision and scope from their previous records and a completely self-contained universe. Frontman Isaac Brock’s worldview had always made room for a fair amount of existential loneliness and drugged madness, but from the opening moments of “3rd Planet”, all of those elements suddenly cohered into something serenely whole. ',
    status: 'available',
  },

  band7: {
    name: 'The Strokes',
    image: 'https://cdn3.pitchfork.com/albums/7419/homepage_large.c1b895b7.jpg',
    desc:
      'The Strokes helped to keep alive the romantic notion of pre-Giuliani New York, before the Lower East Side became an amusement park and Times Square became Disneyland. At the time, these guys were naïve enough (and good-looking enough) to firmly believe they were the best band in the world; and for a moment, it actually came true.',
    status: 'available',
  },
  band8: {
    name: 'Sigur Rós',
    image: 'https://cdn.pitchfork.com/albums/7039/homepage_large.e17d9e74.jpg',
    desc:
      'They came from Iceland and Radiohead liked them. That’s about all we knew back when Ágætis Byrjun first starting making its way around near the turn of the decade, but in those days, that was enough to get people intrigued. Discovering the music of Sigur Rós was an active process, because a series of questions inevitably followed: How do you pronounce their name?',
    status: 'available',
  },
  band9: {
    name: 'Panda Bear',
    image: 'https://cdn3.pitchfork.com/albums/9839/homepage_large.e2dd97fd.jpg',
    desc:
      'Person Pitch is the third solo album from Noah Lennox, yet it seems difficult to take measure of the album except as it relates to his regular work as a member of Animal Collective. (This is partially because Person Pitch was the first AC-related album to really lure some of their more skeptical listeners into the tent.).',
    status: 'available',
  },
  band10: {
    name: 'The Avalanches',
    image: 'https://cdn.pitchfork.com/albums/381/homepage_large.cfca747e.jpg',
    desc:
      'Here’s a curious album: It’s constructed like a hip-hop record, it flows with the momentum of a great dance mix, but its component parts seem to come from strange places– musical soundtracks, oddball comedy routines, and easy-listening thrift-store pop from the 60s and 70s.',
    status: 'available',
  },
};

export default bands;
